/* In Care cart drawer — moved out of sections/cart-drawer.liquid on 2026-10-02 so browsers cache it
   (was ~70 KB inline on every page). Loaded with defer; both parts already wait for DOMContentLoaded or
   look up the drawer at run time, so behaviour is unchanged. Edit HERE, not in the section. */
/* ---- Part 1: drawer controller ---- */
/**
 * In Care cart drawer controller — inlined so this section has zero
 * dependencies. Guarded so repeated section renders never double-bind.
 *
 * Every mutation: Cart AJAX API with this section bundled into the response
 * (one round trip), rendered straight into the drawer. Nothing about price,
 * discount or stock is computed in JS.
 *
 * NOTE: this block lives inside a Liquid file, so it must never contain a
 * double opening curly brace or a curly-percent pair.
 */
(function () {
  'use strict';
  if (window.__incareCartDrawerBooted) return;
  window.__incareCartDrawerBooted = true;

  /* fetch as it was when this script loaded — only the fetch watcher below calls it. */
  var prevFetch = window.fetch;
  var ownCall = 0;
  var lastFocus = null;
  var queue = Promise.resolve();   // cart mutations run one after another, never dropped
  var pending = 0;
  var qtyWant = {};                // line key -> quantity asked for, not yet confirmed
  var qtyTimer = {};
  var lastRender = 0;
  var emitting = false;            // true while WE dispatch theme events
  var dirty = false;               // cart may have changed elsewhere (other tab, back button)

  function root() { return document.getElementById('incare-cart-drawer'); }

  /**
   * Every drawer request goes through the page's CURRENT window.fetch, so
   * Shopify's analytics (which wraps fetch after this script loads) sees
   * drawer adds and fires AddToCart for Meta / Google. ownCall tells the
   * fetch watcher below that the request is ours.
   */
  function apiFetch(input, init) {
    ownCall++;
    try { return window.fetch(input, init); } finally { ownCall--; }
  }
  function isOpen() { var el = root(); return !!el && el.getAttribute('aria-hidden') === 'false'; }
  function closestOf(target, sel) { return target && target.closest ? target.closest(sel) : null; }

  /**
   * Work that READS layout (scroll positions, focus, sizes) runs in the
   * browser's next frame. Doing it straight after a DOM change forces an
   * extra full-page layout — ~85 ms on this store's pages. The timer is only
   * a fallback for background tabs, where frames do not run.
   */
  function nextFrame(fn) {
    var done = false;
    function run() { if (done) return; done = true; fn(); }
    if (window.requestAnimationFrame) requestAnimationFrame(run);
    setTimeout(run, 150);
  }
  /* Two frames later: the new element has been painted once, so a CSS transition can start from it. */
  function afterPaint(fn) {
    var done = false;
    function run() { if (done) return; done = true; fn(); }
    if (window.requestAnimationFrame) requestAnimationFrame(function () { requestAnimationFrame(run); });
    setTimeout(run, 300);
  }

  /**
   * The id Shopify renders this section under. Inside a section group it is
   * "sections--<n>__cart-drawer" — asking for plain "cart-drawer" returns
   * nothing, which is why the drawer used to go stale until a page reload.
   */
  function sectionId() {
    var el = root();
    return (el && el.dataset.sectionId) || 'cart-drawer';
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cssEsc(v) {
    return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/["\\]/g, '\\$&');
  }

  /* --------------------------------------------------------------- money fmt */

  /* Braces are assembled at runtime so Liquid never sees a brace pair in JS. */
  var LB = String.fromCharCode(123, 123);
  var RB = String.fromCharCode(125, 125);

  function moneyFormat() {
    var el = root();
    return (el && el.dataset.moneyFormat) || ('\u20B9' + LB + 'amount' + RB);
  }
  function group(num, dec, thousands) {
    var parts = Number(num).toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands || ',');
    return parts.join('.');
  }
  /* Matches Liquid's money_without_trailing_zeros used everywhere else. */
  function money(cents) {
    var v = Number(cents) / 100;
    return moneyFormat().replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount_no_decimals': return group(v, 0, ',');
        case 'amount_with_comma_separator': return group(v, 2, '.').replace(/\.(\d\d)$/, ',$1').replace(/,00$/, '');
        case 'amount_no_decimals_with_comma_separator': return group(v, 0, '.');
        case 'amount_with_apostrophe_separator': return group(v, 2, "'").replace(/\.00$/, '');
        default: return group(v, 2, ',').replace(/\.00$/, '');
      }
    });
  }

  /* ------------------------------------------------------------------- state */

  /* Busy = a cart write is queued, in flight, or a quantity tap is waiting to be sent. */
  function updateBusy() {
    var el = root();
    if (el) el.classList.toggle('icd--busy', pending > 0 || Object.keys(qtyTimer).length > 0);
  }

  /** Serialise cart writes so rapid taps queue up instead of being thrown away. */
  function enqueue(task) {
    pending++;
    updateBusy();
    var run = queue.then(task);
    queue = run.catch(function () {}).then(function () { pending--; updateBusy(); });
    return run;
  }

  var toastTimer = null;
  function toast(text, bad) {
    var el = root();
    var panel = el && el.querySelector('.icd__panel');
    if (!panel || !text) return;
    var old = panel.querySelector('.icd__toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'icd__toast' + (bad ? ' is-bad' : '');
    t.setAttribute('role', bad ? 'alert' : 'status');
    t.textContent = text;
    t.addEventListener('click', function () { t.remove(); });
    panel.appendChild(t);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { if (t.parentNode) t.remove(); }, 3600);
  }

  function readJson(r) {
    return r.json().catch(function () { return {}; }).then(function (d) {
      if (!r.ok) {
        var msg = typeof d.description === 'string' ? d.description : (d.message || 'Something went wrong. Please try again.');
        throw new Error(msg);
      }
      return d;
    });
  }

  /** POST to the Cart API; withSections bundles this drawer's fresh HTML. */
  function mutate(url, body, withSections) {
    body = body || {};
    if (withSections) {
      body.sections = sectionId();
      body.sections_url = window.location.pathname;
    }
    return apiFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(readJson);
  }

  function getCart() {
    return apiFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(readJson);
  }

  /**
   * Tell the theme (header cart dot, cart count, free-shipping widgets) that
   * the cart changed. Our own listener ignores events we emit.
   */
  function announce(cart, baseEvent) {
    if (!cart || typeof cart.item_count !== 'number') return;
    emitting = true;
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: baseEvent || 'line-item:change', cart: cart }
      }));
    } catch (e) {}
    emitting = false;
  }
  function announceFromServer(baseEvent) {
    return getCart().then(function (cart) { announce(cart, baseEvent); }).catch(function () {});
  }

  /* --------------------------------------------------------------- rendering */

  function applySections(data) {
    var html = data && data.sections && data.sections[sectionId()];
    if (html) { render(html); return Promise.resolve(); }
    return refresh();
  }

  function refresh() {
    var id = sectionId();
    var u = new URL(window.location.href);
    u.searchParams.set('sections', id);
    return apiFetch(u.pathname + u.search, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (data) {
        if (data && data[id]) return render(data[id]);
        /* Last resort: re-read the drawer out of the full page. */
        return apiFetch(window.location.pathname, { cache: 'no-store' })
          .then(function (r) { return r.text(); })
          .then(render);
      })
      .catch(function () { toast('Could not update your bag. Please refresh the page.', true); });
  }

  /** What the shopper was doing, so a re-render never wipes it. */
  function snapshot(el) {
    var s = { scroll: 0, details: {}, fields: {}, pinMsg: null, focus: null };
    var body = el.querySelector('.icd__body');
    if (body) s.scroll = body.scrollTop;
    var seen = {};
    el.querySelectorAll('details').forEach(function (d) {
      var k = d.className + '#' + (seen[d.className] = (seen[d.className] || 0) + 1);
      s.details[k] = d.open;
    });
    ['[data-icd-note]', '[data-icd-coupon]', '[data-icd-pin]'].forEach(function (sel) {
      var f = el.querySelector(sel);
      if (f) s.fields[sel] = f.value;
    });
    var m = el.querySelector('[data-icd-pin-msg]');
    if (m && !m.hidden && m.dataset.live === '1') s.pinMsg = { html: m.innerHTML, cls: m.className };
    /* Colour / size already picked on cross-sell cards, and how far the strip is scrolled. */
    s.xsel = {};
    el.querySelectorAll('[data-icd-xcard]').forEach(function (card) {
      var picks = {};
      xSelects(card).forEach(function (sel) { picks[sel.dataset.icdXopt] = sel.value; });
      s.xsel[card.dataset.productId] = picks;
    });
    var strip = el.querySelector('[data-icd-strip]');
    s.stripX = strip ? strip.scrollLeft : 0;
    var a = document.activeElement;
    if (a && el.contains(a)) s.focus = focusKey(a);
    return s;
  }

  function restore(el, s) {
    nextFrame(function () {
      var body = el.querySelector('.icd__body');
      if (body && s.scroll) body.scrollTop = s.scroll;
      var strip = el.querySelector('[data-icd-strip]');
      if (strip && s.stripX) strip.scrollLeft = s.stripX;
      if (s.focus) {
        var target = el.querySelector(s.focus);
        if (!target || target.disabled) target = el.querySelector('.icd__x');
        if (target) { try { target.focus({ preventScroll: true }); } catch (e) {} }
      }
    });
    el.querySelectorAll('[data-icd-xcard]').forEach(function (card) {
      var picks = s.xsel && s.xsel[card.dataset.productId];
      if (!picks) return;
      xSelects(card).forEach(function (sel) {
        var val = picks[sel.dataset.icdXopt];
        if (val != null && Array.prototype.some.call(sel.options, function (o) { return o.value === val; })) sel.value = val;
      });
    });
    var seen = {};
    el.querySelectorAll('details').forEach(function (d) {
      var k = d.className + '#' + (seen[d.className] = (seen[d.className] || 0) + 1);
      if (k in s.details) d.open = s.details[k];
    });
    Object.keys(s.fields).forEach(function (sel) {
      var f = el.querySelector(sel);
      if (f && s.fields[sel] !== '' && f.value !== s.fields[sel]) f.value = s.fields[sel];
    });
    var m = el.querySelector('[data-icd-pin-msg]');
    if (m && s.pinMsg) {
      m.innerHTML = s.pinMsg.html;
      m.className = s.pinMsg.cls;
      m.hidden = false;
      m.dataset.live = '1';
    }
  }

  var FOCUS_ATTRS = [
    'data-icd-qty', 'data-icd-remove', 'data-icd-size', 'data-icd-swap', 'data-icd-add',
    'data-icd-pin', 'data-icd-pin-check', 'data-icd-coupon', 'data-icd-coupon-apply',
    'data-icd-coupon-remove', 'data-icd-note', 'data-icd-checkout'
  ];
  function focusKey(a) {
    if (a.classList && a.classList.contains('icd__x')) return '.icd__x';
    for (var i = 0; i < FOCUS_ATTRS.length; i++) {
      var n = FOCUS_ATTRS[i];
      if (!a.hasAttribute(n)) continue;
      var v = a.getAttribute(n);
      var sel = '[' + n + (v ? '="' + cssEsc(v) + '"' : '') + ']';
      if (a.dataset.icdStep) sel += '[data-icd-step="' + a.dataset.icdStep + '"]';
      if (n === 'data-icd-swap' || n === 'data-icd-size') sel += '[data-line-key="' + cssEsc(a.dataset.lineKey || '') + '"]';
      return sel;
    }
    return null;
  }

  function render(html) {
    if (!html) return;
    var start = html.indexOf('id="incare-cart-drawer"');
    var cut = start > -1 ? html.indexOf('<style', start) : -1;
    if (cut > -1) html = html.slice(0, cut);
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    var fresh = wrap.querySelector('#incare-cart-drawer');
    var current = root();
    if (!fresh || !current) return;

    lastRender = Date.now();
    dirty = false;
    stopAdding();
    var keep = snapshot(current);

    ['.icd__head', '.icd__body'].forEach(function (sel) {
      var a = current.querySelector(sel);
      var b = fresh.querySelector(sel);
      if (a && b) a.replaceWith(b);
    });
    var oldFoot = current.querySelector('.icd__foot');
    var newFoot = fresh.querySelector('.icd__foot');
    if (oldFoot && newFoot) oldFoot.replaceWith(newFoot);
    else if (oldFoot && !newFoot) oldFoot.remove();
    else if (!oldFoot && newFoot) current.querySelector('.icd__panel').appendChild(newFoot);

    current.dataset.cartCount = fresh.dataset.cartCount;
    current.dataset.cartTotal = fresh.dataset.cartTotal;
    current.dataset.cartPids = fresh.dataset.cartPids || '';

    restore(current, keep);
    paintPending();
    syncBubbles(fresh.dataset.cartCount);
    initXCards();
    restorePin(false);
    packLater();
    document.dispatchEvent(new CustomEvent('incare:cart:updated', {
      detail: { count: Number(fresh.dataset.cartCount), total: Number(fresh.dataset.cartTotal) }
    }));
  }

  /** Keep the theme's own header cart indicators in sync. */
  function syncBubbles(count) {
    var n = Number(count) || 0;
    document.querySelectorAll(
      '.cart-count,.header__cart-count,cart-count,.cart-count-bubble span:first-child'
    ).forEach(function (el) {
      if (el.closest('#incare-cart-drawer')) return;
      el.textContent = n;
    });
    document.querySelectorAll('cart-dot,.header__cart-dot').forEach(function (el) {
      el.classList.toggle('is-visible', n > 0);
    });
  }

  /* --------------------------------------------------------------- open/close */

  function open() {
    var el = root();
    if (!el || isOpen()) return;
    lastFocus = document.activeElement;
    el.setAttribute('aria-hidden', 'false');
    var panel = el.querySelector('.icd__panel');
    if (panel) panel.removeAttribute('inert');
    document.documentElement.classList.add('icd-locked');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    nextFrame(function () {
      var x = isOpen() && root().querySelector('.icd__x');
      if (x && !root().contains(document.activeElement)) { try { x.focus({ preventScroll: true }); } catch (e) {} }
    });
    if (dirty) refresh();
    /* A saved pincode gets today's date the first time the bag is opened —
       never a stale date from an earlier visit. */
    if (!pinFresh) { pinFresh = true; restorePin(true); }
    packLater();
  }

  function close() {
    var el = root();
    if (!el || !isOpen()) return;
    hideYay(true);
    el.setAttribute('aria-hidden', 'true');
    var panel = el.querySelector('.icd__panel');
    if (panel) panel.setAttribute('inert', '');
    document.documentElement.classList.remove('icd-locked');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function trapFocus(e) {
    var el = root();
    if (!isOpen() || e.key !== 'Tab') return;
    var nodes = el.querySelectorAll(
      'a[href],button:not([disabled]),select,textarea,input,summary,[tabindex]:not([tabindex="-1"])'
    );
    var list = Array.prototype.filter.call(nodes, function (n) {
      return n.offsetParent !== null && n.getAttribute('tabindex') !== '-1';
    });
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------------------------------------------------------------- quantity */

  function lineEl(key) {
    var el = root();
    if (!el) return null;
    var lines = el.querySelectorAll('.icd__line');
    for (var i = 0; i < lines.length; i++) if (lines[i].dataset.lineKey === key) return lines[i];
    return null;
  }

  function paintQty(line, q) {
    var v = line.querySelector('[data-icd-qty-value]');
    if (v) v.textContent = q;
    var max = Number(line.dataset.max) || 0;
    var plus = line.querySelector('[data-icd-step="1"]');
    if (plus) plus.disabled = max > 0 && q >= max;
    line.classList.add('is-pending');
    if (q === 0) line.classList.add('is-removing');
  }

  /* Re-apply taps that are still in flight after a re-render. */
  function paintPending() {
    Object.keys(qtyWant).forEach(function (k) {
      var l = lineEl(k);
      if (l) paintQty(l, qtyWant[k]);
    });
  }

  /**
   * Optimistic stepper: the number changes on tap, taps are coalesced for
   * 350 ms, then ONE change request sends the final quantity.
   */
  function stepQty(key, step) {
    var line = lineEl(key);
    if (!line) return;
    var shown = qtyWant.hasOwnProperty(key) ? qtyWant[key] : Number(line.dataset.qty) || 0;
    var next = Math.max(0, shown + step);
    var max = Number(line.dataset.max) || 0;
    if (step > 0 && max > 0 && next > max) {
      toast('Only ' + max + ' available — that is all we have in stock.', true);
      return;
    }
    if (next === shown) return;
    qtyWant[key] = next;
    paintQty(line, next);
    clearTimeout(qtyTimer[key]);
    if (next === 0) { commitQty(key); return; }
    qtyTimer[key] = setTimeout(function () { commitQty(key); }, 350);
    updateBusy();
  }

  function commitQty(key) {
    clearTimeout(qtyTimer[key]);
    delete qtyTimer[key];
    updateBusy();
    return enqueue(function () {
      if (!qtyWant.hasOwnProperty(key)) return;
      var want = qtyWant[key];
      var before = cartState();
      return mutate('/cart/change.js', { id: key, quantity: want }, true)
        .then(function (cart) {
          if (qtyWant[key] === want) delete qtyWant[key];
          return applySections(cart).then(function () { announce(cart); cheerIfUnlocked(before); });
        })
        .catch(function (e) {
          delete qtyWant[key];
          toast(e.message, true);
          return refresh();
        });
    });
  }

  function flushQty() {
    Object.keys(qtyTimer).forEach(function (k) { commitQty(k); });
    return queue;
  }

  /* ------------------------------------------------ instant "adding" state */

  var addingTimer = null;
  /** Theme adds take 1-2 s on this store; open the bag at once with a placeholder line. */
  function startAdding() {
    var el = root();
    if (!el) return;
    dirty = false;   /* the add's own response brings the fresh bag; no extra refresh */
    open();
    el.classList.add('icd--adding');
    var body = el.querySelector('.icd__body');
    if (body && !body.querySelector('.icd__adding')) {
      var sk = document.createElement('div');
      sk.className = 'icd__adding';
      sk.setAttribute('role', 'status');
      sk.innerHTML = '<span class="icd__skimg"></span><span class="icd__sklines"><i></i><i></i><b>Adding to your bag\u2026</b></span>';
      body.insertBefore(sk, body.firstChild);
      nextFrame(function () { if (sk.isConnected) body.scrollTop = 0; });
    }
    clearTimeout(addingTimer);
    addingTimer = setTimeout(function () { stopAdding(); refresh(); }, 12000);
  }
  function stopAdding() {
    clearTimeout(addingTimer);
    var el = root();
    if (!el) return;
    el.classList.remove('icd--adding');
    var sk = el.querySelector('.icd__adding');
    if (sk) sk.remove();
  }

  /* ------------------------------------------------- add-to-cart celebration */

  var lastAdded = null;        // items from the theme's variant:add event
  var yayTimer = null;

  function cartState() {
    var el = root();
    var d = el ? el.dataset : {};
    return { total: Number(d.cartTotal) || 0, count: Number(d.cartCount) || 0 };
  }
  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function celebrationOn() {
    var el = root();
    return !!el && el.dataset.celebrate === 'true';
  }

  /**
   * Confetti with no library: one canvas above the drawer, a few hundred
   * rotating paper bits, removed as soon as the last one fades.
   */
  function confetti(big) {
    var el = root();
    if (!el || reduceMotion() || el.dataset.confetti !== 'true') return;
    var cv = document.createElement('canvas');
    var ctx = cv.getContext && cv.getContext('2d');
    if (!ctx) return;
    cv.className = 'icd__confetti';
    cv.setAttribute('aria-hidden', 'true');
    el.appendChild(cv);

    var W = window.innerWidth;
    var H = window.innerHeight;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = W * dpr;
    cv.height = H * dpr;
    ctx.scale(dpr, dpr);

    var colours = [
      el.dataset.colorPink || '#E8447C',
      el.dataset.colorNavy || '#161B4D',
      '#F9C6D8', '#FFC24B', '#3CCB8E', '#7C9CFF'
    ];
    /* Where the panel ends up (CSS: full width up to 600px, else min(440px, 100vw)). */
    var pw = W <= 600 ? W : Math.min(440, W);
    var panel = { left: W - pw, right: W, top: 0, width: pw };
    var bits = [];
    function burst(x, y, angle, spread, count, power) {
      for (var i = 0; i < count; i++) {
        var a = angle + (Math.random() - 0.5) * spread;
        var v = power * (0.55 + Math.random() * 0.6);
        bits.push({
          x: x + (Math.random() - 0.5) * 30, y: y,
          vx: Math.cos(a) * v, vy: Math.sin(a) * v,
          g: 0.16 + Math.random() * 0.1, w: 5 + Math.random() * 5, h: 7 + Math.random() * 7,
          r: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.35,
          c: colours[i % colours.length], round: Math.random() < 0.28
        });
      }
    }
    var cx = panel.left + panel.width / 2;
    burst(cx, panel.top + 70, -Math.PI / 2, Math.PI * 1.15, big ? 110 : 80, big ? 15 : 12);
    if (big) {
      burst(panel.left + 10, H - 20, -Math.PI / 2 + 0.45, 0.7, 70, 20);
      burst(panel.right - 10, H - 20, -Math.PI / 2 - 0.45, 0.7, 70, 20);
    }

    var start = 0;
    var life = big ? 2600 : 1600;
    function frame(t) {
      if (!start) start = t;
      var age = t - start;
      var fade = age > life - 700 ? Math.max(0, (life - age) / 700) : 1;
      ctx.clearRect(0, 0, W, H);
      ctx.globalAlpha = fade;
      for (var i = 0; i < bits.length; i++) {
        var b = bits[i];
        b.vx *= 0.985;
        b.vy = b.vy * 0.985 + b.g;
        b.x += b.vx;
        b.y += b.vy;
        b.r += b.vr;
        ctx.save();
        ctx.translate(b.x, b.y);
        ctx.rotate(b.r);
        ctx.fillStyle = b.c;
        if (b.round) {
          ctx.beginPath();
          ctx.arc(0, 0, b.w / 2, 0, 6.283);
          ctx.fill();
        } else {
          ctx.fillRect(-b.w / 2, -b.h / 2, b.w, b.h * Math.abs(Math.cos(b.r * 1.7)) + 1);
        }
        ctx.restore();
      }
      if (age < life) requestAnimationFrame(frame);
      else cv.remove();
    }
    requestAnimationFrame(frame);
    /* Frames pause in a background tab; never leave a canvas behind. */
    setTimeout(function () { if (cv.parentNode) cv.remove(); }, life + 1500);
  }

  function hideYay(now) {
    clearTimeout(yayTimer);
    var el = root();
    var pop = el && el.querySelector('.icd__yay');
    if (!pop) return false;
    if (now || reduceMotion()) { pop.remove(); return true; }
    pop.classList.add('is-out');
    setTimeout(function () { if (pop.parentNode) pop.remove(); }, 260);
    return true;
  }

  /** The line that was just added: exact key, else variant id, else the newest line. */
  function addedLine(item) {
    if (item && item.key) {
      var byKey = lineEl(item.key);
      if (byKey) return byKey;
    }
    var vid = item ? String(item.variant_id || item.id || '') : '';
    var lines = root() ? root().querySelectorAll('.icd__line') : [];
    for (var i = 0; vid && i < lines.length; i++) {
      if (String(lines[i].dataset.lineKey).split(':')[0] === vid) return lines[i];
    }
    return lines[0] || null;
  }

  function glowLine(line) {
    if (!line) return;
    line.classList.add('is-new');
    nextFrame(function () {
      var body = line.isConnected && root().querySelector('.icd__body');
      if (!body) return;
      var lr = line.getBoundingClientRect();
      var br = body.getBoundingClientRect();
      if (lr.top < br.top || lr.bottom > br.bottom) body.scrollTop += lr.top - br.top - 12;
    });
  }

  function node(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /**
   * Pop-up at the top of the bag after any add: what was added, how far to
   * free shipping (with a bigger burst when this add unlocks it), and the
   * two next steps. Auto-hides; the countdown pauses while it is hovered.
   */
  /*
   * One pop-up per add. The same add can be reported twice — the theme's
   * cart:change and the external-write safety net below — and on a slow
   * connection both used to reach this point, showing the pop-up twice.
   */
  var lastCelebrate = 0;
  var CELEBRATE_GAP = 3000;

  function celebrate(items, before) {
    var el = root();
    if (!el) return;
    var item = (items && items[0]) || null;
    var line = addedLine(item);
    glowLine(line);
    var now = Date.now();
    if (now - lastCelebrate < CELEBRATE_GAP) return;
    lastCelebrate = now;
    if (!celebrationOn()) { toast('Added to your bag'); return; }
    if (el.dataset.celebrateMode === 'first') {
      try {
        if (sessionStorage.getItem('incare:celebrated')) { toast('Added to your bag'); return; }
        sessionStorage.setItem('incare:celebrated', '1');
      } catch (e) {}
    }

    var threshold = Number(el.dataset.freeShipThreshold) || 0;
    var after = cartState().total;
    var was = before ? before.total : after;
    var unlocked = threshold > 0 && was < threshold && after >= threshold;

    hideYay(true);
    var old = el.querySelector('.icd__toast');
    if (old) old.remove();
    var panel = el.querySelector('.icd__panel');
    if (!panel) return;

    var pop = node('div', 'icd__yay' + (unlocked ? ' is-win' : ''));
    pop.setAttribute('role', 'status');
    pop.setAttribute('aria-live', 'polite');

    var x = node('button', 'icd__yayx', '✕');
    x.type = 'button';
    x.setAttribute('data-icd-yay-x', '');
    x.setAttribute('aria-label', 'Dismiss');
    pop.appendChild(x);

    var title = node('p', 'icd__yaytitle');
    title.appendChild(node('span', 'icd__yayemoji', unlocked ? '🥳' : '🎉'));
    title.appendChild(node('span', null, unlocked
      ? (el.dataset.yayUnlock || 'Woohoo! Free shipping unlocked')
      : (el.dataset.yayTitle || 'Yay! Added to your bag')));
    pop.appendChild(title);

    /* The item itself — from the add response, falling back to the rendered line. */
    var name = (item && item.product_title) || (line && line.querySelector('.icd__linename') ? line.querySelector('.icd__linename').textContent : '');
    if (name) {
      var row = node('div', 'icd__yayitem');
      var thumb = line && line.querySelector('.icd__thumb img');
      var src = thumb ? (thumb.currentSrc || thumb.src) : (item && item.image) || '';
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        row.appendChild(img);
      }
      var txt = node('div');
      txt.appendChild(node('b', null, name.trim()));
      var variant = item && item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      if (!variant && line) {
        var sizeSel = line.querySelector('[data-icd-size]');
        var bits = [];
        line.querySelectorAll('.icd__linemeta').forEach(function (m) { if (!m.classList.contains('icd__linemeta--ok')) bits.push(m.textContent.replace(/^[^:]+:\s*/, '')); });
        if (sizeSel && sizeSel.options[sizeSel.selectedIndex]) bits.push(sizeSel.options[sizeSel.selectedIndex].textContent.replace(/^[^:]+:\s*/, '').trim());
        variant = bits.join(' / ');
      }
      if (variant) txt.appendChild(node('span', null, variant.replace(/\s*\/\s*/g, ' · ')));
      var cents = item ? (item.final_price != null ? item.final_price : item.price) : null;
      var priceText = cents != null ? money(cents) : (line && line.querySelector('.icd__lineprice b') ? line.querySelector('.icd__lineprice b').textContent : '');
      if (priceText) txt.appendChild(node('em', null, priceText + (item && item.quantity > 1 ? ' × ' + item.quantity : '')));
      row.appendChild(txt);
      pop.appendChild(row);
    }

    /* Free-shipping nudge. */
    if (threshold > 0) {
      var msg = node('div', 'icd__yaymsg' + (after >= threshold ? ' is-win' : ''));
      if (after >= threshold) {
        msg.textContent = unlocked ? '🎁 This bag now ships FREE' : '✓ Free shipping on this bag';
      } else {
        var line1 = node('p');
        line1.appendChild(document.createTextNode('Add '));
        line1.appendChild(node('b', null, money(threshold - after)));
        line1.appendChild(document.createTextNode(' more for FREE shipping'));
        if (el.querySelector('[data-icd-xsell]')) {
          var picks = node('button', 'icd__yaylink', 'See picks ↓');
          picks.type = 'button';
          picks.setAttribute('data-icd-yay-picks', '');
          line1.appendChild(document.createTextNode(' · '));
          line1.appendChild(picks);
        }
        msg.appendChild(line1);
        var bar = node('div', 'icd__yaybar');
        var fill = node('i');
        fill.style.width = Math.min(100, Math.round(was / threshold * 100)) + '%';
        bar.appendChild(fill);
        msg.appendChild(bar);
        var fillTo = Math.min(100, Math.round(after / threshold * 100)) + '%';
      }
      pop.appendChild(msg);
    }

    var cta = node('div', 'icd__yaycta');
    var shop = node('button', 'icd__yayshop', 'Keep shopping');
    shop.type = 'button';
    shop.setAttribute('data-icd-yay-shop', '');
    var go = node('button', 'icd__yaygo', 'Checkout →');
    go.type = 'button';
    go.setAttribute('data-icd-checkout', '');
    cta.appendChild(shop);
    cta.appendChild(go);
    pop.appendChild(cta);

    /* A plain timer decides how long it stays — CSS animations stall in
       background tabs, so the countdown bar is decoration only. */
    var secs = Math.max(1, Number(el.dataset.yaySeconds) || 1);
    var timer = node('i', 'icd__yaytimer');
    timer.style.animationDuration = secs + 's';
    pop.appendChild(timer);

    panel.appendChild(pop);
    if (fillTo) afterPaint(function () { fill.style.width = fillTo; });
    nextFrame(function () { confetti(unlocked); });
    yayTimer = setTimeout(function () { hideYay(); }, secs * 1000);
    document.dispatchEvent(new CustomEvent('incare:cart:celebrate', { detail: { item: item, freeShippingUnlocked: unlocked } }));
  }

  /* Quantity taps that push the bag over the free-shipping line also get a cheer. */
  function cheerIfUnlocked(before) {
    var el = root();
    if (!el || !celebrationOn() || !before) return;
    var threshold = Number(el.dataset.freeShipThreshold) || 0;
    var after = cartState().total;
    if (threshold > 0 && before.total < threshold && after >= threshold) {
      confetti(true);
      toast('🥳 ' + (el.dataset.yayUnlock || 'Woohoo! Free shipping unlocked'));
    }
  }

  /* -------------------------------------------------------------- operations */

  function add(id, qty, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    return enqueue(function () {
      var before = cartState();
      return mutate('/cart/add.js', { items: [{ id: Number(id), quantity: qty || 1 }] }, true)
        .then(function (data) {
          return applySections(data).then(function () {
            open();
            celebrate(data.items, before);
            return announceFromServer('line-item:change');
          });
        })
        .catch(function (e) {
          toast(e.message, true);
          if (btn && btn.isConnected) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        });
    });
  }

  /**
   * Size / pack swap. ADD the new variant first, then remove the old line —
   * if the add fails (sold out) the bag is untouched, and a variant that is
   * already in the bag keeps its own quantity instead of being overwritten.
   */
  function swapVariant(lineKey, toVariantId, qty, control) {
    if (!lineKey || !toVariantId) return;
    var fromId = String(lineKey).split(':')[0];
    if (String(fromId) === String(toVariantId)) return;
    var line = lineEl(lineKey);
    if (line) line.classList.add('is-pending');
    if (control) control.setAttribute('aria-busy', 'true');
    return enqueue(function () {
      return mutate('/cart/add.js', { items: [{ id: Number(toVariantId), quantity: Number(qty) || 1 }] }, false)
        .then(function () { return mutate('/cart/change.js', { id: lineKey, quantity: 0 }, true); })
        .then(function (cart) { return applySections(cart).then(function () { announce(cart); }); })
        .catch(function (e) { toast(e.message, true); return refresh(); });
    });
  }

  /* -------------------------------------------------------- pack upgrade */

  /**
   * Some products carry a "Pack" option where each tier (Pack of 1 / 2 / 3) is
   * its own variant at its own price. A shopper who instead raises the quantity
   * of Pack of 1 pays the single price three times over, while the product page
   * promises the pack price. This finds the cheapest set of pack variants for
   * the pieces in a line and moves the bag onto it.
   *
   * Only families that occupy ONE line are touched: if the bag already holds
   * two tiers of the same colour and size, that is a deliberate choice.
   */
  var packDone = {};
  var packBusy = false;
  var packTimer = null;

  function packLater() {
    clearTimeout(packTimer);
    /* Long enough for the write that triggered this render to settle and for
       the 350 ms quantity-tap window to close. */
    packTimer = setTimeout(packSync, 450);
  }

  function packRead(line) {
    var tag = line.querySelector('[data-icd-packs]');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }

  /** Cheapest combination of tiers for `total` pieces - exact, not greedy. */
  function packPlan(total, tiers) {
    if (!(total > 0) || total > 36 || !tiers || !tiers.length) return null;
    var best = [0], pick = [null], i, j, t, c;
    for (i = 1; i <= total; i++) {
      best[i] = Infinity;
      pick[i] = null;
      for (j = 0; j < tiers.length; j++) {
        t = tiers[j];
        if (!(t.n > 0) || t.n > i || best[i - t.n] === Infinity) continue;
        c = best[i - t.n] + t.price;
        if (c < best[i]) { best[i] = c; pick[i] = t; }
      }
    }
    if (best[total] === Infinity) return null;
    var counts = {}, left = total, guard = 0;
    while (left > 0 && guard++ < 64) {
      t = pick[left];
      if (!t) return null;
      counts[t.id] = (counts[t.id] || 0) + 1;
      left -= t.n;
    }
    return left === 0 ? { cost: best[total], counts: counts } : null;
  }

  function packSync() {
    var el = root();
    if (!el || el.dataset.packUpgrade !== 'true') return;
    if (packBusy || !isOpen()) return;
    if (pending > 0 || Object.keys(qtyTimer).length) return;   /* shopper is mid-tap */

    var lines = el.querySelectorAll('.icd__line');
    var seen = {}, rows = [], i, d;
    for (i = 0; i < lines.length; i++) {
      d = packRead(lines[i]);
      if (!d || !d.key) continue;
      seen[d.family] = (seen[d.family] || 0) + 1;
      rows.push(d);
    }
    for (i = 0; i < rows.length; i++) {
      d = rows[i];
      if (seen[d.family] !== 1 || packDone[d.key]) continue;
      var plan = packPlan(d.n * d.qty, d.tiers);
      if (!plan) continue;
      var now = d.price * d.qty;
      if (plan.cost >= now) continue;
      packDone[d.key] = true;            /* never retry the same line in a loop */
      return packApply(d, plan, now - plan.cost);
    }
  }

  function packApply(data, plan, saved) {
    var adds = [], keep = 0;
    Object.keys(plan.counts).forEach(function (id) {
      /* The line's own variant is RE-QUANTIFIED, never re-added: Shopify merges
         an add into the existing line, and zeroing that line afterwards would
         take the added pieces with it. */
      if (String(id) === String(data.variantId)) keep = plan.counts[id];
      else adds.push({ id: Number(id), quantity: plan.counts[id] });
    });

    var ids = Object.keys(plan.counts);
    var label = 'Pack';
    if (ids.length === 1) {
      var only = (data.tiers || []).filter(function (t) { return String(t.id) === ids[0]; })[0];
      if (only && only.label) label = only.label;
    }

    var line = lineEl(data.key);
    if (line) line.classList.add('is-pending');
    packBusy = true;
    var done = function () { packBusy = false; };
    return enqueue(function () {
      /* Add the other tiers first: if one is sold out the bag is untouched. */
      var step = adds.length ? mutate('/cart/add.js', { items: adds }, false) : Promise.resolve();
      return step
        .then(function () { return mutate('/cart/change.js', { id: data.key, quantity: keep }, true); })
        .then(function (cart) {
          return applySections(cart).then(function () {
            announce(cart);
            toast(label + ' price applied \u2014 you saved ' + money(saved));
          });
        })
        .catch(function (e) { toast(e.message, true); return refresh(); });
    }).then(done, done);
  }

  /* ------------------------------------------------------------------ coupon */

  function showMsg(el, text, ok) {
    if (!el) return;
    el.hidden = false;
    el.textContent = text;
    el.classList.toggle('is-ok', !!ok);
    el.classList.toggle('is-bad', !ok);
  }

  function codeSaving(cart, code) {
    var up = code.toUpperCase();
    var total = 0;
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (String(d.title || '').toUpperCase() === up) total += d.total_allocated_amount || 0;
    });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application && String(a.discount_application.title || '').toUpperCase() === up) total += a.amount || 0;
      });
    });
    return total;
  }

  function reportCoupon(cart, code) {
    var live = document.querySelector('#incare-cart-drawer [data-icd-coupon-msg]');
    var entry = (cart.discount_codes || []).filter(function (d) {
      return String(d.code).toUpperCase() === code.toUpperCase();
    })[0];
    if (entry && entry.applicable) {
      /* The freshly rendered bag already says "<CODE> applied — you save …"
         with a Remove link; only fill in when that line is missing. */
      if (!live || live.hidden || !live.textContent.trim()) {
        var off = codeSaving(cart, code);
        showMsg(live, code.toUpperCase() + ' applied' + (off ? ' — you save ' + money(off) : ''), true);
      }
      var input = document.querySelector('#incare-cart-drawer [data-icd-coupon]');
      if (input) input.value = '';
    } else {
      showMsg(live, code.toUpperCase() + ' is not valid for this bag.', false);
    }
  }

  /**
   * Cart API update.js takes a `discount` field; older storefronts ignore it,
   * so fall back to the /discount/<code> route when the reply has no codes.
   */
  function applyCoupon(code, msgEl, btn) {
    code = (code || '').trim();
    if (!code) return showMsg(msgEl, 'Enter a coupon code first.', false);
    showMsg(msgEl, 'Checking…', true);
    if (btn) btn.setAttribute('aria-busy', 'true');
    return enqueue(function () {
      return mutate('/cart/update.js', { discount: code }, true)
        .then(function (cart) {
          if (Array.isArray(cart.discount_codes)) {
            var up = code.toUpperCase();
            var entry = cart.discount_codes.filter(function (d) { return String(d.code).toUpperCase() === up; })[0];
            if (!entry || !entry.applicable) {
              /* Shopify keeps a bad code on the cart and checkout would show it again. */
              var keep = cart.discount_codes
                .filter(function (d) { return d.applicable && String(d.code).toUpperCase() !== up; })
                .map(function (d) { return d.code; }).join(',');
              return mutate('/cart/update.js', { discount: keep }, true).then(function (clean) {
                return applySections(clean).then(function () { reportCoupon(cart, code); announce(clean); });
              });
            }
            return applySections(cart).then(function () { reportCoupon(cart, code); announce(cart); });
          }
          return apiFetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { headers: { Accept: 'application/json' } })
            .then(getCart)
            .then(function (c) { return refresh().then(function () { reportCoupon(c, code); announce(c); }); });
        })
        .catch(function () {
          showMsg(document.querySelector('#incare-cart-drawer [data-icd-coupon-msg]'), 'Could not check that code. Try again.', false);
        })
        .then(function () { if (btn && btn.isConnected) btn.removeAttribute('aria-busy'); });
    });
  }

  function removeCoupon() {
    return enqueue(function () {
      return mutate('/cart/update.js', { discount: '' }, true)
        .then(function (cart) { return applySections(cart).then(function () { announce(cart); }); })
        .catch(function (e) { toast(e.message, true); });
    });
  }

  /* ------------------------------------------------ smart cross-sell cards */

  /**
   * Each cross-sell card carries its variants as JSON:
   *   v:   [id, [option values], available 1/0, price, compare_at_price]
   *   img: colour -> image URL
   * so size / colour can be picked and added without leaving the drawer.
   */
  function xData(card) {
    if (!card.__icdX) {
      var node = card.querySelector('[data-icd-xdata]');
      try { card.__icdX = JSON.parse(node.textContent); } catch (e) { card.__icdX = { v: [], img: {} }; }
    }
    return card.__icdX;
  }
  function xSelects(card) {
    return Array.prototype.slice.call(card.querySelectorAll('[data-icd-xopt]'));
  }
  /* Variants that fit every chosen option; skipIdx ignores one select. */
  function xMatches(card, skipIdx) {
    var sels = xSelects(card);
    return xData(card).v.filter(function (v) {
      return sels.every(function (sel) {
        var k = Number(sel.dataset.icdXopt);
        return k === skipIdx || !sel.value || v[1][k] === sel.value;
      });
    });
  }

  function xHint(card, text) {
    var hint = card.querySelector('[data-icd-xhint]');
    if (!hint) return;
    hint.textContent = text || '';
    hint.hidden = !text;
  }

  /** Grey out sold-out choices, then show the price and photo of the pick. */
  function xSync(card) {
    var d = xData(card);
    xSelects(card).forEach(function (sel) {
      var k = Number(sel.dataset.icdXopt);
      var pool = xMatches(card, k);
      Array.prototype.forEach.call(sel.options, function (o) {
        if (!o.value) return;
        if (!o.dataset.label) o.dataset.label = o.textContent;
        var ok = pool.some(function (v) { return v[2] && v[1][k] === o.value; });
        o.disabled = !ok;
        o.textContent = o.dataset.label + (ok ? '' : ' — sold out');
      });
      var chosen = sel.options[sel.selectedIndex];
      if (chosen && chosen.value && chosen.disabled && sel.hasAttribute('data-icd-xsize')) sel.value = '';
    });

    var fits = xMatches(card, -1);
    var v = fits.filter(function (x) { return x[2]; })[0] || fits[0] || d.v[0];
    var price = card.querySelector('[data-icd-xprice]');
    if (price && v) {
      var off = v[4] > v[3] ? Math.floor((v[4] - v[3]) * 100 / v[4]) : 0;
      price.innerHTML = '<b>' + money(v[3]) + '</b>' +
        (off > 0 ? '<s>' + money(v[4]) + '</s><em>' + off + '% off</em>' : '');
    }

    var ci = Number(card.dataset.colourIndex);
    var img = card.querySelector('.icd__cardimg img');
    if (ci > -1 && img && v) {
      var colSel = card.querySelector('[data-icd-xopt="' + ci + '"]');
      var colour = colSel && colSel.value ? colSel.value : v[1][ci];
      var src = d.img && d.img[colour];
      /* First pass: the server already rendered this colour's photo. */
      if (!img.dataset.colour) img.dataset.colour = colour;
      else if (src && img.dataset.colour !== colour) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
        img.dataset.colour = colour;
      }
    }
  }

  function initXCards() {
    document.querySelectorAll('#incare-cart-drawer [data-icd-xcard]').forEach(xSync);
  }

  function xAdd(card, btn) {
    var missing = xSelects(card).filter(function (s) { return !s.value; })[0];
    if (missing) {
      missing.classList.add('is-missing');
      var what = (missing.options[0] ? missing.options[0].textContent : 'size').replace(/^select\s+/i, '');
      xHint(card, 'Select a ' + what + ' first');
      try { missing.focus({ preventScroll: true }); if (missing.showPicker) missing.showPicker(); } catch (e) {}
      return;
    }
    var v = xMatches(card, -1)[0];
    if (!v || !v[2]) { xHint(card, 'Sold out in this option — pick another.'); return; }
    xHint(card, '');
    return add(v[0], 1, btn);
  }

  /* Desktop arrows for the horizontal strip (touch users just swipe). */
  function scrollStrip(btn) {
    var sec = btn.closest('.icd__sec');
    var strip = sec && sec.querySelector('[data-icd-strip]');
    if (!strip) return;
    strip.scrollBy({ left: Number(btn.dataset.icdScroll) * strip.clientWidth * 0.8, behavior: 'smooth' });
  }

  /* -------------------------------------------------------------- order note */

  var noteTimer = null;
  function saveNote(el) {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      noteTimer = null;
      mutate('/cart/update.js', { note: el.value }, false)
        .then(function () {
          var hint = el.parentNode ? el.parentNode.querySelector('[data-icd-note-hint]') : null;
          if (!hint) return;
          hint.hidden = false;
          setTimeout(function () { hint.hidden = true; }, 2200);
        })
        .catch(function () { toast('Could not save the note.', true); });
    }, 600);
  }

  /* --------------------------------------------------------- pincode / ETA */

  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var METROS = ['110', '400', '560', '600', '700', '500', '411', '380', '122', '201'];
  var pinSeq = 0;
  var placeCache = {};

  function list(str) {
    return String(str || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function range(str, fallback) {
    var m = String(str || '').match(/(\d+)\s*(?:-|–|to)?\s*(\d+)?/);
    if (!m) return fallback;
    var a = Number(m[1]);
    var b = m[2] ? Number(m[2]) : a;
    return [Math.min(a, b), Math.max(a, b)];
  }
  function etaConfig() {
    var d = (root() || {}).dataset || {};
    var origin = d.originPin || '';
    return {
      origin: origin,
      local: list(d.localPrefixes).concat(origin ? [origin.slice(0, 3)] : []),
      region: list(d.regionPrefixes).concat(origin ? [origin.slice(0, 2)] : []),
      cutoff: Number(d.cutoff) || 14,
      cod: d.codNote || '',
      days: {
        local: range(d.etaLocal, [1, 2]),
        region: range(d.etaRegion, [2, 4]),
        metro: range(d.etaMetro, [3, 5]),
        national: range(d.etaNational, [4, 7]),
        remote: range(d.etaRemote, [7, 10])
      }
    };
  }

  /* Postal zones by prefix: 18-19 J&K/Ladakh, 78-79 North-East, 737 Sikkim,
     744 Andaman & Nicobar, 6825x Lakshadweep. */
  function zoneFor(pin, cfg) {
    var p2 = pin.slice(0, 2);
    var p3 = pin.slice(0, 3);
    if (/^(18|19|78|79)/.test(pin) || p3 === '737' || p3 === '744' || /^6825/.test(pin)) return 'remote';
    if (cfg.local.indexOf(p3) > -1) return 'local';
    if (cfg.region.indexOf(p2) > -1) return 'region';
    if (METROS.indexOf(p3) > -1) return 'metro';
    return 'national';
  }

  /* IST is a fixed UTC+5:30 — no DST — so no Intl dependency is needed. */
  function istNow() {
    var n = new Date(Date.now() + 330 * 60000);
    return {
      date: new Date(Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate())),
      minutes: n.getUTCHours() * 60 + n.getUTCMinutes()
    };
  }
  function nextWorkingDay(d) {
    var x = new Date(d.getTime());
    do { x.setUTCDate(x.getUTCDate() + 1); } while (x.getUTCDay() === 0);
    return x;
  }
  function addWorkingDays(d, n) {
    var x = d;
    for (var i = 0; i < n; i++) x = nextWorkingDay(x);
    return x;
  }
  function fmtDate(d) {
    return DAYS[d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()];
  }

  function estimate(pin, cfg) {
    var zone = zoneFor(pin, cfg);
    var span = cfg.days[zone];
    var now = istNow();
    var dispatch = now.date;
    var cutoffMin = cfg.cutoff * 60;
    var today = dispatch.getUTCDay() !== 0 && now.minutes < cutoffMin;
    if (!today) dispatch = nextWorkingDay(dispatch);
    return {
      zone: zone,
      from: addWorkingDays(dispatch, span[0]),
      to: addWorkingDays(dispatch, span[1]),
      minutesLeft: today ? cutoffMin - now.minutes : 0
    };
  }

  /* India Post directory — used to confirm the pincode exists and name the place. */
  function lookupPlace(pin) {
    if (placeCache.hasOwnProperty(pin)) return Promise.resolve(placeCache[pin]);
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 3000);
    return apiFetch('https://api.postalpincode.in/pincode/' + pin, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (d) {
        clearTimeout(timer);
        var res = d && d[0];
        if (!res) return null;
        if (res.Status === 'Error' || !res.PostOffice || !res.PostOffice.length) {
          return (placeCache[pin] = { invalid: true });
        }
        var po = res.PostOffice.filter(function (o) { return o.DeliveryStatus === 'Delivery'; })[0] || res.PostOffice[0];
        return (placeCache[pin] = { name: [po.District, po.State].filter(Boolean).join(', ') });
      })
      .catch(function () { clearTimeout(timer); return null; /* slow or offline: estimate without a place name */ });
  }

  function endpointCheck(pin) {
    var el = root();
    var endpoint = el ? el.dataset.pinEndpoint : '';
    if (!endpoint) return Promise.resolve(null);
    return apiFetch(endpoint + (endpoint.indexOf('?') > -1 ? '&' : '?') + 'pincode=' + pin, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function paintPin(msgEl, st) {
    if (!msgEl) return;
    msgEl.hidden = false;
    msgEl.dataset.live = '1';
    msgEl.className = 'icd__pinmsg ' + (st.bad ? 'is-bad' : st.loading ? 'is-loading' : 'is-ok');
    msgEl.textContent = '';
    var b = document.createElement('b');
    b.textContent = st.bad || st.title || 'Checking delivery date…';
    msgEl.appendChild(b);
    if (st.sub) {
      var span = document.createElement('span');
      span.textContent = st.sub;
      msgEl.appendChild(span);
    }
    if (st.hint) {
      var em = document.createElement('em');
      em.textContent = st.hint;
      msgEl.appendChild(em);
    }
  }

  function checkPin(input, msgEl, opts) {
    opts = opts || {};
    if (!input) return;
    var pin = (input.value || '').replace(/\D/g, '').slice(0, 6);
    input.value = pin;
    if (!/^[1-9]\d{5}$/.test(pin)) {
      if (!opts.quiet) paintPin(msgEl, { bad: 'Enter a valid 6-digit pincode.' });
      return;
    }
    var seq = ++pinSeq;
    var cfg = etaConfig();
    var prevText = msgEl && !msgEl.hidden ? msgEl.textContent.trim() : '';
    var btn = msgEl && msgEl.parentNode ? msgEl.parentNode.querySelector('[data-icd-pin-check]') : null;
    if (btn) btn.setAttribute('aria-busy', 'true');
    paintPin(msgEl, { loading: true });

    Promise.all([lookupPlace(pin), endpointCheck(pin)]).then(function (res) {
      if (seq !== pinSeq) return;
      var live = document.querySelector('#incare-cart-drawer [data-icd-pin-msg]') || msgEl;
      if (!live) return;
      var place = res[0];
      var api = res[1];
      var liveBtn = live.parentNode && live.parentNode.querySelector('[data-icd-pin-check]');
      if (liveBtn) liveBtn.removeAttribute('aria-busy');

      if ((place && place.invalid) || (api && api.serviceable === false)) {
        return paintPin(live, {
          bad: place && place.invalid
            ? 'We couldn’t find pincode ' + pin + '. Please check it.'
            : 'Sorry, we don’t deliver to ' + pin + ' yet.'
        });
      }

      var est = estimate(pin, cfg);
      var title = api && api.eta ? 'Delivery by ' + api.eta : 'Delivery by ' + fmtDate(est.to);
      var parts = [];
      var where = (place && place.name) || (api && api.zone) || '';
      if (where) parts.push(where);
      if (api && api.cod === false) parts.push('Prepaid only');
      else if (cfg.cod) parts.push(cfg.cod);
      var hint = '';
      if (est.minutesLeft > 0 && est.minutesLeft <= 12 * 60) {
        var h = Math.floor(est.minutesLeft / 60);
        var m = est.minutesLeft % 60;
        hint = 'Order within ' + (h ? h + 'h ' : '') + m + 'm to ship today';
      }
      paintPin(live, { title: title, sub: parts.join(' · '), hint: hint });

      try { localStorage.setItem('incare:pincode', pin); } catch (e) {}
      /* Saved on the order so the team sees what was promised. Skipped when
         nothing changed, so opening the drawer never writes to the cart. */
      var saved = title + (where ? ' (' + where + ')' : '');
      if (saved !== prevText) {
        mutate('/cart/update.js', { attributes: { pincode: pin, pincode_eta: saved } }, false).catch(function () {});
      }
    });
  }

  /** Put the last pincode back and, when asked, recompute its date. */
  var pinFresh = false;
  function restorePin(recompute) {
    var field = document.querySelector('#incare-cart-drawer [data-icd-pin]');
    if (!field) return;
    try {
      var saved = localStorage.getItem('incare:pincode');
      if (saved && !field.value) field.value = saved;
    } catch (e) {}
    if (recompute && field.value) {
      var msg = document.querySelector('#incare-cart-drawer [data-icd-pin-msg]');
      checkPin(field, msg, { quiet: true });
    }
  }

  /* ---------------------------------------------------------------- checkout */

  /**
   * Checkout handoff: waits for queued quantity changes, then GoKwik SDK if
   * present, then any injected GoKwik button, then Shopify /checkout — the
   * shopper is never trapped in the drawer.
   */
  function checkout(btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var done = function () { if (btn && btn.isConnected) { btn.disabled = false; btn.removeAttribute('aria-busy'); } };
    flushQty()
      .then(getCart)
      .then(function (cart) {
        if (!cart || cart.item_count === 0) { done(); return refresh(); }
        document.dispatchEvent(new CustomEvent('incare:checkout:start', { detail: { cart: cart } }));
        /* Checkout takes over the screen — the bag gets out of the way first. */
        close();
        /* GoKwik: its own trigger, else the SDK with the merchant config it expects. */
        if (typeof window.triggerGokwikCustomCheckout === 'function') {
          window.triggerGokwikCustomCheckout();
          done();
          return;
        }
        if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === 'function' && window.merchantInfo) {
          window.gokwikSdk.initCheckout(window.merchantInfo);
          done();
          return;
        }
        var gk = document.querySelector('.gokwik-checkout-btn,[data-gokwik-checkout],#gokwik-buy-now');
        if (gk) { gk.click(); done(); return; }
        window.location.href = '/checkout';
      })
      .catch(function () { window.location.href = '/checkout'; });
  }

  /* ---------------------------------------------------------------- bindings */

  document.addEventListener('click', function (e) {
    var t = closestOf(e.target,
      '[data-icd-close],[data-icd-open],[data-icd-remove],[data-icd-qty],[data-icd-add],' +
      '[data-icd-swap],[data-icd-checkout],[data-icd-coupon-apply],[data-icd-coupon-remove],[data-icd-pin-check],' +
      '[data-icd-xadd],[data-icd-scroll],[data-icd-yay-x],[data-icd-yay-shop],[data-icd-yay-picks]'
    );
    if (!t) return;

    if (t.hasAttribute('data-icd-close')) { e.preventDefault(); return close(); }
    if (t.hasAttribute('data-icd-open')) { e.preventDefault(); return open(); }
    if (t.hasAttribute('data-icd-remove')) {
      e.preventDefault();
      var rk = t.getAttribute('data-icd-remove');
      var rl = lineEl(rk);
      qtyWant[rk] = 0;
      if (rl) paintQty(rl, 0);
      return commitQty(rk);
    }
    if (t.hasAttribute('data-icd-qty')) {
      e.preventDefault();
      if (t.disabled) return;
      return stepQty(t.getAttribute('data-icd-qty'), Number(t.dataset.icdStep) || 0);
    }
    if (t.hasAttribute('data-icd-add')) {
      e.preventDefault();
      if (t.disabled) return;
      return add(t.getAttribute('data-icd-add'), 1, t);
    }
    if (t.hasAttribute('data-icd-swap')) {
      e.preventDefault();
      return swapVariant(t.dataset.lineKey, t.dataset.toVariant, t.dataset.qty || 1, t);
    }
    if (t.hasAttribute('data-icd-pin-check')) {
      e.preventDefault();
      var pinBox = t.closest('.icd__coupon');
      return checkPin(pinBox.querySelector('[data-icd-pin]'), pinBox.querySelector('[data-icd-pin-msg]'));
    }
    if (t.hasAttribute('data-icd-yay-x')) { e.preventDefault(); return hideYay(); }
    if (t.hasAttribute('data-icd-yay-shop')) { e.preventDefault(); hideYay(true); return close(); }
    if (t.hasAttribute('data-icd-yay-picks')) {
      e.preventDefault();
      hideYay();
      var xs = document.querySelector('#incare-cart-drawer [data-icd-xsell]');
      var xb = document.querySelector('#incare-cart-drawer .icd__body');
      if (xs && xb) xb.scrollTo({ top: xs.getBoundingClientRect().top - xb.getBoundingClientRect().top + xb.scrollTop - 8, behavior: reduceMotion() ? 'auto' : 'smooth' });
      return;
    }
    if (t.hasAttribute('data-icd-checkout')) { e.preventDefault(); hideYay(true); return checkout(t); }
    if (t.hasAttribute('data-icd-coupon-apply')) {
      e.preventDefault();
      var box = t.closest('.icd__coupon');
      return applyCoupon(box.querySelector('[data-icd-coupon]').value, box.querySelector('[data-icd-coupon-msg]'), t);
    }
    if (t.hasAttribute('data-icd-coupon-remove')) { e.preventDefault(); return removeCoupon(); }
    if (t.hasAttribute('data-icd-xadd')) {
      e.preventDefault();
      if (t.disabled) return;
      var card = t.closest('[data-icd-xcard]');
      return card ? xAdd(card, t) : undefined;
    }
    if (t.hasAttribute('data-icd-scroll')) { e.preventDefault(); return scrollStrip(t); }
  });

  document.addEventListener('change', function (e) {
    var opt = closestOf(e.target, '[data-icd-xopt]');
    if (opt) {
      var xcard = opt.closest('[data-icd-xcard]');
      opt.classList.remove('is-missing');
      if (xcard) { xHint(xcard, ''); xSync(xcard); }
      return;
    }
    var sel = closestOf(e.target, '[data-icd-size]');
    if (!sel) return;
    var key = sel.dataset.lineKey;
    var line = lineEl(key);
    var qty = qtyWant.hasOwnProperty(key) ? qtyWant[key] : (line ? line.dataset.qty : sel.dataset.qty);
    return swapVariant(key, sel.value, qty, sel);
  });

  document.addEventListener('input', function (e) {
    var note = closestOf(e.target, '[data-icd-note]');
    if (note) return saveNote(note);
    var pin = closestOf(e.target, '[data-icd-pin]');
    if (pin) {
      var clean = pin.value.replace(/\D/g, '').slice(0, 6);
      if (clean !== pin.value) pin.value = clean;
      /* Six digits typed = check straight away, no extra tap needed. */
      if (clean.length === 6) {
        var pb = pin.closest('.icd__coupon');
        checkPin(pin, pb && pb.querySelector('[data-icd-pin-msg]'));
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) { if (!hideYay()) close(); return; }
    trapFocus(e);
    if (e.key !== 'Enter' || !e.target.matches) return;
    if (e.target.matches('[data-icd-pin]')) {
      e.preventDefault();
      var pb = e.target.closest('.icd__coupon');
      return checkPin(e.target, pb.querySelector('[data-icd-pin-msg]'));
    }
    if (e.target.matches('[data-icd-coupon]')) {
      e.preventDefault();
      var box = e.target.closest('.icd__coupon');
      return applyCoupon(e.target.value, box.querySelector('[data-icd-coupon-msg]'), box.querySelector('[data-icd-coupon-apply]'));
    }
  });

  /* ------------------------------------------------ theme integration (Impact) */

  /**
   * The theme's <product-form> already POSTs /cart/add.js itself. Before it
   * does, it asks which sections to bundle — we add ours, so its response
   * carries a freshly rendered drawer and no second request is needed.
   */
  document.addEventListener('cart:prepare-bundled-sections', function (e) {
    if (e.detail && Array.isArray(e.detail.sections) && e.detail.sections.indexOf(sectionId()) === -1) {
      e.detail.sections.push(sectionId());
    }
    /* The theme only gets here after the form passed validation, so the add is really happening. */
    if (Date.now() - addIntentAt < 3000) startAdding();
  });

  /* Remember that an add-to-cart form was just submitted (capture runs before the theme). */
  var addIntentAt = 0;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form[action*="/cart/add"]')) addIntentAt = Date.now();
  }, true);

  /* Shopify refused the add (sold out, limit): say so in the bag the shopper is looking at. */
  document.addEventListener('cart:error', function (e) {
    var el = root();
    if (!el || !el.classList.contains('icd--adding')) return;
    stopAdding();
    toast((e.detail && e.detail.error) || 'Could not add that item. Please try again.', true);
  }, true);

  /* Theme announces every cart change (add, quick-buy, cart page). */
  var lastThemeAdd = 0;
  document.addEventListener('variant:add', function (e) {
    lastAdded = (e.detail && e.detail.items) || null;
    lastThemeAdd = Date.now();
  }, true);

  document.addEventListener('cart:change', function (e) {
    if (emitting) return;
    var d = e.detail || {};
    var before = cartState();
    var html = d.cart && d.cart.sections && d.cart.sections[sectionId()];
    var done = html ? Promise.resolve(render(html)) : refresh();
    if (d.baseEvent === 'variant:add') {
      var items = lastAdded;
      lastAdded = null;
      done.then(function () { open(); celebrate(items, before); });
    }
  });

  ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxProduct:added'].forEach(function (evt) {
    document.addEventListener(evt, function () { if (!emitting) refresh(); });
  });

  /**
   * Fallback for add-to-cart forms that NO other script handles (apps, custom
   * blocks). If the theme's product form already took the submit
   * (defaultPrevented), stay out of it — handling it twice is what used to
   * add every product to the bag two times.
   */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented) return;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var sub = e.submitter;
    if (sub && (sub.name === 'checkout' || /checkout/.test(sub.getAttribute('formaction') || ''))) return;
    e.preventDefault();
    var fd = new FormData(form);
    fd.set('sections', sectionId());
    fd.set('sections_url', window.location.pathname);
    var btn = sub || form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    enqueue(function () {
      var before = cartState();
      return apiFetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(readJson)
        .then(function (d) {
          return applySections(d).then(function () {
            open();
            celebrate(d.items || [d], before);
            return announceFromServer('line-item:change');
          });
        })
        .catch(function (err) { open(); toast(err.message, true); })
        .then(function () {
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        });
    });
  });

  /**
   * Safety net for apps that change the cart with their own fetch / XHR and
   * fire no event: re-render shortly after, unless a render already happened.
   */
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  function watchExternal(url) {
    if (!CART_WRITE.test(url)) return;
    var at = Date.now();
    var before = cartState();
    setTimeout(function () {
      /* Already handled: the drawer re-rendered, or this add was announced
         by the theme (cart:change) / already celebrated. */
      if (lastRender >= at || lastThemeAdd >= at - 1000 || lastCelebrate >= at - 1000) return;
      refresh().then(function () {
        if (!/\/cart\/add/.test(url) || cartState().count <= before.count) return;
        if (lastThemeAdd >= at - 1000 || lastCelebrate >= at - 1000) return;
        open();
        celebrate(null, before);
      });
    }, 700);
  }
  try {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || String(input);
      var mine = ownCall > 0;
      var p = prevFetch.call(window, input, init);
      if (!mine) p.then(function (r) { if (r && r.ok) watchExternal(url); }, function () {});
      return p;
    };
    var xOpen = XMLHttpRequest.prototype.open;
    var xSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__icdUrl = url;
      return xOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      x.addEventListener('load', function () {
        if (x.status >= 200 && x.status < 300 && x.__icdUrl) watchExternal(String(x.__icdUrl));
      });
      return xSend.apply(this, arguments);
    };
  } catch (e) {}

  /* Open the drawer for any existing cart trigger instead of navigating. */
  document.addEventListener('click', function (e) {
    var link = closestOf(e.target,
      'a[href$="/cart"],a[href*="/cart?"],[data-cart-drawer-toggle],.header__cart-link,' +
      '[href="#cart-drawer"],[aria-controls="cart-drawer"]'
    );
    if (!link || link.closest('#incare-cart-drawer')) return;
    if (link.hasAttribute('data-no-drawer')) return;
    e.preventDefault();
    open();
  }, true);

  /**
   * Backup in case a GoKwik update stops calling .close(): the moment its
   * checkout window is added to the page, the bag closes. Only direct
   * children of <body> are watched, and only while the bag is open.
   */
  var GK_CHECKOUT = '.gokwik-modalwrapper,.gokwik-modal,.gokwik-iframe,.gokwik-loader';
  function watchGoKwik() {
    try {
      new MutationObserver(function (list) {
        if (!isOpen()) return;
        for (var i = 0; i < list.length; i++) {
          var added = list[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.matches(GK_CHECKOUT) || n.querySelector(GK_CHECKOUT))) { close(); return; }
          }
        }
      }).observe(document.body, { childList: true });
    } catch (e) {}
  }
  if (document.body) watchGoKwik();
  else document.addEventListener('DOMContentLoaded', watchGoKwik);

  /* Back/forward cache and other tabs can change the cart behind our back. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    dirty = true;
    refresh();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') dirty = true;
  });

  /**
   * Compatibility shim: some theme and app code calls
   * document.querySelector('cart-drawer').open(). Define the element only if
   * the theme has not already defined it, so nothing throws and any trigger
   * opens THIS drawer.
   */
  try {
    if (window.customElements && !window.customElements.get('cart-drawer')) {
      window.customElements.define('cart-drawer', class extends HTMLElement {
        open() { open(); }
        close() { close(); }
        show() { open(); }
        hide() { close(); }
      });
    }
  } catch (e) {}

  function boot() {
    var el = root();
    if (el && el.getAttribute('aria-hidden') !== 'false') {
      var panel = el.querySelector('.icd__panel');
      if (panel) panel.setAttribute('inert', '');
    }
    /**
     * GoKwik owns the checkout buttons. Before it opens its checkout it looks
     * for the page's cart drawer ([data-cart-drawer]) and calls .close() on
     * it — give it one, so only the checkout is left on screen.
     */
    if (el) {
      el.close = function () { close(); };
      el.open = function () { open(); };
    }
    syncBubbles(el ? el.dataset.cartCount : 0);
    initXCards();
    restorePin(false);
    if (new URLSearchParams(location.search).has('cart-open')) open();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId && root()) boot();
  });

  /* Theme editor: selecting this section (or one of its offer blocks) shows the drawer. */
  function isMine(e) { return !!(e.detail && root() && e.detail.sectionId === sectionId()); }
  document.addEventListener('shopify:section:select', function (e) { if (isMine(e)) open(); });
  document.addEventListener('shopify:block:select', function (e) { if (isMine(e)) open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (isMine(e)) close(); });

  window.InCareCart = {
    open: open, close: close, refresh: refresh, add: add, checkout: checkout
  };
})();

/* ---- Part 2: cross-sell size panel + delivery ETA ---- */
  /*
   * Cross-sell size panel (simplified drawer, 2026-10).
   * "+ Add" with no size chosen opens the card's size buttons instead of a
   * dropdown; tapping a size fills the card's hidden size select and presses
   * "+ Add" again, so the drawer's own add logic (xAdd) does the adding.
   * Capture phase on document = runs before the drawer's click handler and
   * survives every re-render of the section.
   */
  (function () {
    if (window.__icdSizePanel) return;
    window.__icdSizePanel = true;

    function closePanels(except) {
      document.querySelectorAll('#incare-cart-drawer [data-icd-szpick]').forEach(function (p) {
        if (p !== except) p.hidden = true;
      });
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('#incare-cart-drawer [data-icd-xadd], #incare-cart-drawer [data-icd-xsizechip], #incare-cart-drawer [data-icd-szclose]');
      if (!t) return;
      var card = t.closest('[data-icd-xcard]');
      var pick = card && card.querySelector('[data-icd-szpick]');
      var sel = card && card.querySelector('[data-icd-xsize]');
      if (!pick || !sel) return;

      if (t.hasAttribute('data-icd-szclose')) {
        e.preventDefault(); e.stopPropagation();
        pick.hidden = true;
        return;
      }

      if (t.hasAttribute('data-icd-xadd')) {
        if (sel.value) return; /* size known: let the drawer add it */
        e.preventDefault(); e.stopPropagation();
        closePanels(pick);
        pick.hidden = false;
        var first = pick.querySelector('[data-icd-xsizechip]:not([disabled])');
        if (first) { try { first.focus({ preventScroll: true }); } catch (err) {} }
        return;
      }

      /* A size button. */
      e.preventDefault(); e.stopPropagation();
      if (t.disabled) return;
      sel.value = t.getAttribute('data-icd-xsizechip');
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      pick.hidden = true;
      var btn = card.querySelector('[data-icd-xadd]');
      if (btn) btn.click();
    }, true);

    /*
     * Delivery date for the confidence card. Same rules as the pincode
     * check: IST clock, dispatch today before the cutoff hour (else next
     * working day), Sundays never count. "Get it by <latest date>" reads
     * more certain than "4-6 days" and never over-promises. A pincode ETA
     * already saved on the cart wins.
     */
    var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function istToday() {
      /* IST is a fixed UTC+5:30; work in UTC getters on a shifted date. */
      return new Date(Date.now() + 330 * 60000);
    }
    function plusWorkingDays(d, n) {
      var x = new Date(d.getTime());
      while (n > 0) {
        x.setUTCDate(x.getUTCDate() + 1);
        if (x.getUTCDay() !== 0) n--;
      }
      return x;
    }
    function fmt(d) { return DAYS[d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()]; }
    function fillEta(root) {
      var el = root.querySelector('[data-icd-eta-auto]');
      if (!el || el.dataset.done) return;
      el.dataset.done = '1';
      if (!/^Delivery in/.test(el.textContent.trim())) return; /* a saved pincode ETA is already shown */
      var range = String(el.dataset.days || '4-6').split('-');
      var lo = parseInt(range[0], 10), hi = parseInt(range[1] || range[0], 10);
      if (!(lo > 0)) return;
      hi = Math.min(hi, 6); /* store promise: delivery within 6 days at most */
      var drawer = document.getElementById('incare-cart-drawer');
      var cutoff = parseInt(drawer && drawer.dataset.cutoff, 10) || 14;
      var now = istToday();
      var dispatch = new Date(now.getTime());
      if (now.getUTCDay() === 0 || now.getUTCHours() >= cutoff) dispatch = plusWorkingDays(now, 1);
      var a = plusWorkingDays(dispatch, lo);
      var b = plusWorkingDays(dispatch, hi);
      /* 2026-10-22: show the range (earliest - latest) instead of only the latest date */
      el.textContent = a.getTime() === b.getTime() ? 'Get it by ' + fmt(b) : 'Arrives ' + fmt(a) + ' – ' + fmt(b);
    }
    var drawerRoot = document.getElementById('incare-cart-drawer');
    if (drawerRoot) {
      fillEta(drawerRoot);
      new MutationObserver(function () { fillEta(drawerRoot); }).observe(drawerRoot, { childList: true, subtree: true });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('#incare-cart-drawer [data-icd-szpick]:not([hidden])');
      if (open) { e.stopPropagation(); open.hidden = true; }
    }, true);
  })();
